// src/js/reducers/index.js
import * as types from "../constants/action-types";
import Sorter from '../utils/sorter';


export default function permissionReducer(state = [], action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.LOAD_PERMISSION_TYPES_SUCCESS:

            return  Sorter.sort(action.permissions, 'permissionType');
        
        default:
            return state;
    };
};


